import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [copied, setCopied] = useState(false);
  const email = "igndunno@gmail.com";

  const handleCopyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    
    // Also try to open the mailto link as a fallback
    window.location.href = `mailto:${email}`;
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container glass-panel">
        <h2 className="section-title">Get In Touch</h2>
        <p className="contact-text">
          I'm currently looking for new opportunities in Cyber Risk/GRC, Risk Analytics, Data/ML, or Software Engineering. 
          Whether you have a question or just want to say hi, my inbox is always open!
        </p>

        <a href={`mailto:${email}`} onClick={handleCopyEmail} className="contact-btn bounce">
          {copied ? "Email Copied! ✅" : "Say Hello"}
        </a>

        <div className="social-links">
          <a href="https://www.linkedin.com/in/marcus~yap/" target="_blank" rel="noreferrer" className="social-tag">
            LinkedIn
          </a>
          <a href="https://github.com/MarcusGitty" target="_blank" rel="noreferrer" className="social-tag">
            GitHub
          </a>
          <a href={`mailto:${email}`} onClick={handleCopyEmail} className="social-tag">
            {copied ? "Copied!" : "Email"}
          </a>
        </div>
      </div>
      
      <footer className="footer">
        <p>Built with ❤️ by Marcus Yap Kwan Rui.</p>
      </footer>
    </section>
  );
};

export default Contact;
